import { Component, OnInit, ViewChild } from '@angular/core';
import { AjaxService } from '../ajax.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AlertController } from '@ionic/angular';
import { GlobalService } from '../global.service';
import { Router } from '@angular/router';
import { I18nService } from '../shared/i18n.service';
import { IonDatetime, IonModal } from '@ionic/angular';
interface ScheduledTask {
    title: string;
    desc: string;
    startTime: Date;
    endTime: Date;
    dueDate: Date;
    noteId: number;
    calendarId: number;
    eventId: string;
    projectName: string;
    liproOrderNr: string;
}

@Component({
    selector: 'app-calendar',
    templateUrl: './calendar.page.html',
    styleUrls: ['./calendar.page.scss'],
    standalone: false,
})
export class CalendarPage implements OnInit {
    @ViewChild('rescheduleModal') rescheduleModal: IonModal;
    @ViewChild('reschedulePicker') reschedulePicker: IonDatetime;

    constructor(
        private global: GlobalService,
        private ajax: AjaxService,
        private snackBar: MatSnackBar,
        private alertController: AlertController,
        private router: Router,
        public i18n: I18nService
    ) {}

    scheduledTasks: ScheduledTask[] = [];
    taskToReschedule: any = null;

    dateHighlights: {
        date: string;
        textColor: string;
        backgroundColor: string;
        border: string;
    }[] = [];

    ngOnInit() {
        if (!this.global.isLoggedIn) {
            console.log('Log out for some reason');
            this.router.navigateByUrl('login');
        }
    }

    //
    private today: Date;
    ionViewWillEnter() {
        if (this.global.isLoggedIn) {
            this.today = new Date();
            this.loadTasksForMonth(
                this.today.getFullYear(),
                this.today.getMonth() + 1
            );
        }
    }

    async loadTasksForMonth(year: number, month: number) {
        const params = {
            user: this.global.username,
            year: year,
            month: month,
        };
        console.log('Getting calendar...');
        console.log(`Current tasks: ${this.scheduledTasks}`);
        try {
            const response: any = await this.ajax.get('getCalendar', params);
            if (response.status === 'OK' && response.schedule) {
                console.log(
                    `sucesfully got these tasks: ${this.scheduledTasks}`
                );

                console.log('Successfully got calendar...\n');
                console.log(JSON.stringify(response.schedule));

                this.scheduledTasks = response.schedule.map((task: any) => {
                    const startTime = new Date(
                        `${task.ScheduledDate}T${task.StartTime || '00:00:00'}`
                    );
                    const endTime = new Date(
                        `${task.ScheduledDate}T${task.EndTime || '00:00:00'}`
                    );
                    return {
                        title: task.Titel,
                        desc: task.Bericht,
                        startTime: startTime,
                        endTime: endTime,
                        dueDate: task.DueDate
                            ? new Date(task.DueDate)
                            : new Date('2024-01-01T00:00:00Z'),
                        noteId: task.ID,
                        calendarId: task.CalendarID,
                        eventId: task.GoogleEventID,
                        liproOrderNr: task.LiproOrderNr,
                        projectName: task.Omschrijving,
                    };
                });
                this.updateDateHighlights();
            }
        } catch (error) {
            console.log(`failed to these tasks: ${this.scheduledTasks}`);

            console.log(`Error: ${JSON.stringify(error)} `);
        }
    }

    async deleteEvent(eventId: string) {
        console.log(`Trying to delete note ${eventId} from device`);
        const loading = this.snackBar.open(
            `${this.i18n.tr('[en]Deleting event')}: ${eventId} ${this.i18n.tr(
                '[en]from user'
            )} ${this.global.username}`
        );

        const params = {
            user: this.global.username,
            eventId: eventId,
        };
        try {
            const response: any = await this.ajax.get('deleteEvent', params);
            if (response.status === 'OK') {
                console.log(`Successfully deleted event ${eventId}`);
                loading.dismiss();
            }
        } catch (error) {
            console.log(`Error deleting: ${JSON.stringify(error)}`);
            loading.dismiss();
        }
    }

    doRefresh(event: any) {
        this.loadTasksForMonth(
            this.today.getFullYear(),
            this.today.getMonth() + 1
        );
        setTimeout(() => {
            event.target.complete();
        }, 1000);
    }

    async markAsDone(task: any) {
        const loading = this.snackBar.open(
            `${this.i18n.tr('[en]Marking task')} "${task.title}" ${this.i18n.tr(
                '[en]as done'
            )}...`
        );
        console.log('Marking task as done:', task);
        const params = {
            username: this.global.username,
            noteId: task.noteId,
            calendarId: task.calendarId,
            eventId: task.eventId,
        };
        try {
            const response: any = await this.ajax.get('markTaskAsDone', params);
            loading.dismiss();

            if (response.status === 'OK') {
                this.snackBar.open(
                    response.message ||
                        this.i18n.tr('[en]Task marked as done.'),
                    'OK',
                    {
                        duration: 3000,
                    }
                );
                this.loadTasksForMonth(
                    this.today.getFullYear(),
                    this.today.getMonth() + 1
                );
            } else {
                const alert = await this.alertController.create({
                    header: this.i18n.tr('[en]Error'),
                    message:
                        response.error ||
                        this.i18n.tr('[en]Failed to mark task as done.'),
                    buttons: ['OK'],
                });
                await alert.present();
            }
        } catch (error) {
            loading.dismiss();
            console.error('Failed to call markTaskAsDone:', error);
            const alert = await this.alertController.create({
                header: this.i18n.tr('[en]Error'),
                message: this.i18n.tr(
                    '[en]An error occurred while contacting the server.'
                ),
                buttons: ['OK'],
            });
            await alert.present();
        }
    }

    updateDateHighlights() {
        console.log('Running update date highligts');
        const taskCountByDate = new Map<string, number>();

        for (const task of this.scheduledTasks) {
            const dateString = task.startTime.toISOString().split('T')[0];
            const currentCount = taskCountByDate.get(dateString) || 0;
            taskCountByDate.set(dateString, currentCount + 1);
        }
        const highlights = [];
        for (const [date, count] of taskCountByDate.entries()) {
            let backgroundColor = '';
            let border = '';
            if (count >= 3) {
                //? full?
                backgroundColor = 'var(--ion-color-danger-tint)';
                border = 'var(--ion-color-danger-shade)';
            } else if (count >= 1) {
                backgroundColor = 'var(--ion-color-warning-tint)';
                border = 'var(--ion-color-warning-shade)';
            }
            if (backgroundColor) {
                highlights.push({
                    date: date,
                    textColor: 'var(--ion-color-dark-shade)',
                    backgroundColor: backgroundColor,
                    border: border,
                });
            }
        }
        this.dateHighlights = highlights;
    }

    reschedule(task: any) {
        console.log('Opening reschedule modal for task:', task);
        this.taskToReschedule = task;
        this.rescheduleModal.present();
    }

    cancelReschedule() {
        this.rescheduleModal.dismiss();
        this.taskToReschedule = null;
    }

    async confirmReschedule() {
        if (!this.taskToReschedule || !this.reschedulePicker.value) {
            return;
        }

        const loading = this.snackBar.open(
            this.i18n.tr('[en]Rescheduling task...')
        );

        try {
            const newStartDateTime = new Date(
                this.reschedulePicker.value as string
            );

            const originalDuration =
                this.taskToReschedule.endTime.getTime() -
                this.taskToReschedule.startTime.getTime();

            const newEndDateTime = new Date(
                newStartDateTime.getTime() + originalDuration
            );

            const formatDate = (date: Date) => date.toISOString().split('T')[0];
            const formatTime = (date: Date) =>
                date.toTimeString().split(' ')[0];

            const params = {
                calendarId: this.taskToReschedule.calendarId,
                noteId: this.taskToReschedule.noteId,
                eventId: this.taskToReschedule.eventId,
                username: this.global.username,
                titel: this.taskToReschedule.title,
                bericht: this.taskToReschedule.desc,
                newDate: formatDate(newStartDateTime),
                newStartTime: formatTime(newStartDateTime),
                newEndTime: formatTime(newEndDateTime),
            };

            const response: any = await this.ajax.get('rescheduleTask', params);

            if (response.status === 'OK') {
                this.snackBar.open(
                    response.message ||
                        this.i18n.tr('[en]Task rescheduled successfully.'),
                    'OK',
                    { duration: 3000 }
                );
                this.loadTasksForMonth(
                    this.today.getFullYear(),
                    this.today.getMonth() + 1
                );
            } else {
                const alert = await this.alertController.create({
                    header: this.i18n.tr('[en]Error'),
                    message:
                        response.error ||
                        this.i18n.tr('[en]Failed to reschedule the task.'),
                    buttons: ['OK'],
                });
                await alert.present();
            }
        } catch (error) {
            console.error('Failed to call rescheduleTask:', error);
            const alert = await this.alertController.create({
                header: this.i18n.tr('[en]Error'),
                message: this.i18n.tr(
                    '[en]An error occurred while contacting the server.'
                ),
                buttons: ['OK'],
            });
            await alert.present();
        } finally {
            loading.dismiss();
            this.rescheduleModal.dismiss();
            this.taskToReschedule = null;
        }
    }

    public stripHtmlTags(html: string): string {
        if (!html) {
            return '';
        }
        const doc = new DOMParser().parseFromString(html, 'text/html');
        return doc.body.textContent || '';
    }
}
